import React from 'react';
import PageHeader from '../../Global/Pagecomponents/PageHeader';

const About = () => {
    return (
        <div>
            <PageHeader title="About" subtitle="All wood work tools"></PageHeader>
          
        </div>
    );
};

export default About;